import { LangText } from "../LangText";
import { useTranslation } from "react-i18next";

export function Footer() {
  const year = new Date().getFullYear();
  const { t } = useTranslation();
  return (
    <footer className="bg-white">
      <div className="max-w-8xl px-10 mx-auto h-25 flex items-center justify-between text-[20px] font-normal">
        <span>© {year} JapanDX. All rights reserved.</span>
        <div className="flex items-center gap-[45px]">
          <LangText lngKey='5d73785c'>{t('5d73785c')}
          </LangText>
          <LangText onClick={() => window.open('/protocol?id=3', '_blank')} lngKey='39d02547' className="cursor-pointer">{t('39d02547')}
          </LangText>
          <LangText onClick={() => window.open('/protocol?id=2', '_blank')} lngKey='5a8543c4' className="cursor-pointer">{t('5a8543c4')}
          </LangText>
          <LangText lngKey='2c7782ea'>{t('2c7782ea')}
          </LangText>
        </div>
      </div>
    </footer>
  );
}

